import { X } from "lucide-solid";
import { splitProps } from "solid-js";
import { twJoin } from "tailwind-merge";
import CrossIcon from "~/Icons/crossIcon.svg?component-solid";
import { Button, type ButtonMainProps } from "~/solidJs/shared";

type CloseBtnProps = {} & ButtonMainProps<"button">;
export const CloseBtn = (props: CloseBtnProps) => (
	<Button onclick={props.onClick} class={twJoin("absolute top-4 right-4 p-1", props.class)}>
		<CrossIcon class="size-4 text-white" />
	</Button>
);
export const CloseBtnV2 = (props: CloseBtnProps) => {
	const [_, rest] = splitProps(props, ["class"]);
	return (
		<Button
			variant="AccentIcon"
			class={twJoin("p-2 text-text-secondary-v2", props.class)}
			{...rest}
		>
			<X size={16} />
		</Button>
	);
};
